import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const SubstitutionDialog = ({
  open,
  onClose,
  currentSub,
  handleSubChange,
  errors,
  editingIndex,
  addSubstitution,
  updateSubstitution,
  matchDetails
}) => {
  const teams = [
    { value: matchDetails.teamA, label: matchDetails.teamA },
    { value: matchDetails.teamB, label: matchDetails.teamB }
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth disableEnforceFocus>
      <DialogTitle>{editingIndex !== null ? 'Edit Substitution' : 'Add Substitution'}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            label="Jersey In"
            name="jerseyIn"
            type="number"
            value={currentSub.jerseyIn}
            onChange={handleSubChange}
            placeholder="Enter jersey number (1-99)"
            inputProps={{ min: 1, max: 99 }}
            error={!!errors.jerseyIn}
            helperText={errors.jerseyIn}
            fullWidth
          />
          <TextField
            label="Jersey Out"
            name="jerseyOut"
            type="number"
            value={currentSub.jerseyOut}
            onChange={handleSubChange}
            placeholder="Enter jersey number (1-99)"
            inputProps={{ min: 1, max: 99 }}
            error={!!errors.jerseyOut}
            helperText={errors.jerseyOut}
            fullWidth
          />
          <FormControl fullWidth error={!!errors.team}>
            <InputLabel>Team</InputLabel>
            <Select
              name="team"
              value={currentSub.team || ''}
              onChange={handleSubChange}
              label="Team"
            >
              {teams.map((team) => (
                <MenuItem key={team.value} value={team.value}>
                  {team.label}
                </MenuItem>
              ))}
            </Select>
            {errors.team && <Box sx={{ color: 'error.main', fontSize: '0.75rem', mt: 0.5 }}>{errors.team}</Box>}
          </FormControl>
          <TextField
            label="Time of Substitution (minutes)"
            name="time"
            type="number"
            value={currentSub.time}
            onChange={handleSubChange}
            placeholder="Enter time in minutes (0-120)"
            inputProps={{ min: 0, max: 120 }}
            error={!!errors.time}
            helperText={errors.time}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={() => {
          console.log('Dialog button clicked');
          editingIndex !== null ? updateSubstitution() : addSubstitution();
        }} variant="contained">{editingIndex !== null ? 'Update Substitution' : 'Add Substitution'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubstitutionDialog;